import React from "react";
import {
  View,
  ScrollView,
  StyleSheet,
  Platform,
  TextInput,
} from "react-native";

import { decToHHmm, hhMMToDec, navigate } from "../../../helpers/utils";

import appStyles from "../../appStyles";
import Header from "../common/header";
import TimePickerDialog from "../common/TimePickerDialog";
import appPages from "../../../appPages";
import ManaButton from "../common/ManaButton";
import SetupConfig from "../home/cards/onboarding/SetupConfig";

export default class ScheduleTimePage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    const params = this.getArgs() || {};
    let { id_element } = params;

    this.state = {
      hours: 1,
      showTimePicker: false,
      id_element: id_element,
    };
  }

  getArgs() {
    if (this.controller.hasNavigation()) {
      return this.props.route.params;
    } else {
      return this.controller.state.screenArgs?.args;
    }
  }

  goBack = () => {
    this.controller.goBack();
  };

  toggleTimePicker = (isOpen) => {
    this.setState((state) => ({ ...state, showTimePicker: isOpen }));
  };

  saveHours = (hours) => {
    this.setState((state) => ({ ...state, hours: hhMMToDec(hours) }));
    this.toggleTimePicker(false);
  };

  schedule = () => {
    this.setState((state) => ({ ...state, isLoading: true }));

    this.controller.cardActionWithCallback(
      {
        action: "schedule_time",
        hours: this.state.hours,
        id_element: this.state.id_element,
      },
      () => {
        SettingsHelper.updateSetupProgress(this.controller, {
          [SetupConfig.has_scheduled_call.name]: true,
        });

        this.setState((state) => ({ ...state, isLoading: false }));
        navigate(this.controller, appPages.homePage);
      },
    );
  };

  render() {
    const { isLoading, hours, showTimePicker } = this.state;

    return (
      <View style={appStyles.container}>
        <Header
          title="Schedule Time"
          goBack={this.goBack}
          isLoading={isLoading}
          hideAvatar
        />

        <ScrollView style={appStyles.scrollView}>
          <View style={styles.hoursContainer}>
            <TextInput
              name={"schedule_time"}
              keyboardType="numeric"
              style={styles.hoursInput}
              placeholderTextColor="#9C9EB9"
              onFocus={() => this.toggleTimePicker(true)}
              value={decToHHmm(hours)}
            />
          </View>
        </ScrollView>

        <TimePickerDialog
          value={decToHHmm(hours)}
          isOpen={showTimePicker}
          onConfirm={(value) => this.saveHours(value)}
          onClose={() => this.toggleTimePicker(false)}
          use24hFormat
          pickDuration
        />

        <View style={appStyles.footerButtons}>
          <ManaButton
            isMainButton
            disabled={!hours}
            text={"Continue"}
            onPress={this.schedule}
            style={appStyles.bottomButton}
            textStyle={appStyles.bottomButtonText}
          />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  hoursContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    minHeight: 400,
  },
  hoursInput: {
    width: 80,
    textAlign: "center",
    borderBottomWidth: 1,

    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 19,
    lineHeight: 29,
    letterSpacing: 0.972222,
    color: "#2D3142",
    paddingBottom: 5,
  },
});
